import React from 'react';
import classNames from 'classnames';

import styles from './Overlay.module.scss';

const { overlay: overlayClass, 'overlay-layer': overlayLayerClass, visible: visibleClass } = styles;

const Overlay = ({
  closeModal = () => {},
  modalVisible = true,
  closeOnClick = true,
  customClass,
  children
}) => {
  const handleOverlayClick = () => {
    if (!!closeOnClick) {
      closeModal();
    }
  };

  const overlayClasses = classNames(overlayClass, {
    [visibleClass]: modalVisible,
    [customClass]: !!customClass
  });

  return (
    <div className={overlayClasses}>
      {children}
      <div className={overlayLayerClass} onClick={handleOverlayClick} />
    </div>
  );
};

export default Overlay;
